import { useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import Login from "@views/Login/Login";
import { AUA, Auth, ErrorScheme, User } from "client-v2";
import GrandpaLayout from "./GrandpaLayout";
import LetterLayout from "./LetterLayout";
import { useDispatch } from "react-redux";
import { actionsCreators } from "@redux/index";
import { bindActionCreators } from "redux";

function App() {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { setCurrentUser, setIsDesktop, setIsMobile } = bindActionCreators(
		actionsCreators,
		dispatch
	);

	useEffect(() => {
		initServer();
		window.addEventListener("resize", documentProperties);
		documentProperties();
		return () => {
			window.removeEventListener("resize", documentProperties);
		};
	}, []);

	const documentProperties = () => {
		const doc = document.documentElement;
		doc.style.setProperty("--doc-height", `${window.innerHeight}px`);
		doc.style.setProperty("--doc-width", `${window.innerWidth}px`);
		doc.style.setProperty("--nav-bar-height", `72px`);
		doc.style.setProperty("--nav-bar-height-mobile", `62px`);
		if (window.screen.width <= 768) {
			setIsMobile(true);
			setIsDesktop(false);
		} else {
			setIsMobile(false);
			setIsDesktop(true);
		}
	};

	const initServer = async () => {
		const env: any = process.env.REACT_APP_ENV
			? process.env.REACT_APP_ENV
			: process.env.NODE_ENV;
		await AUA.initServer({
			env: env,
			localhost: process.env.REACT_APP_LOCALHOST ? true : false,
			disableTrack: true,
		});
		User.currentAsync({
			include: ["Residence"],
		})
			.then(({ data: user }) => {
				if (user && user.type === "residence") {
					setCurrentUser(user);
					navigate("/abuelos");
				} else {
					Auth.logout({ auth: undefined });
					navigate("/login");
				}
			})
			.catch((error: ErrorScheme) => {
				if (error.code === 403) {
					navigate("/login");
				}
			});
	};

	return (
		<Routes>
			<Route path="/login" element={<Login />} />
			<Route path="/abuelos/*" element={<GrandpaLayout />} />
			<Route path="/cartas/*" element={<LetterLayout />} />
		</Routes>
	);
}

export default App;
